import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Rocket = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M17.496 4c-1.425 0-3.378.256-4.597 1.475C10.794 7.58 9.391 9.03 9.388 9.033c-.24.247-.593.354-.923.283-.007 0-2.248-.435-3.948.504l9.694 9.694c.943-1.702.541-3.919.536-3.944a1.002 1.002 0 01.273-.903l3.536-3.535c1.896-1.896 1.516-5.498 1.271-6.929A14.143 14.143 0 0017.496 4zm-.354 5.718a2 2 0 11-2.828-2.828 2 2 0 012.828 2.828z",
    key: "k0"
  }), React.createElement("path", {
    d: "M20.92 2.384A15.511 15.511 0 0017.496 2c-2.585 0-4.663.713-6.011 2.061A368.762 368.762 0 008.31 7.273c-1.214-.137-4.077-.203-6.017 1.738a.996.996 0 000 1.414l11.313 11.313a.997.997 0 001.414 0c1.954-1.953 1.894-4.814 1.767-6.01l3.184-3.183c3.191-3.191 1.74-9.182 1.677-9.435a1 1 0 00-.728-.726zm-2.363 8.748l-3.536 3.535a.999.999 0 00-.273.903c.005.025.407 2.242-.536 3.944L4.517 9.82c1.7-.938 3.941-.504 3.948-.504.33.07.684-.036.923-.283.003-.003 1.406-1.453 3.512-3.559C14.118 4.256 16.071 4 17.496 4c.947 0 1.793.111 2.332.203.244 1.431.625 5.032-1.271 6.929z",
    key: "k1"
  }), React.createElement("circle", {
    cx: 15.728,
    cy: 8.304,
    r: 2,
    key: "k2"
  }), React.createElement("path", {
    d: "M5 16c-2 1-2 5-2 5s3 0 5-2l-3-3z",
    key: "k3"
  }));
});
Rocket.displayName = 'Rocket';
export var RocketDimensions = {
  height: 24,
  width: 24
};